import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  Grid2,
  IconButton,
  InputAdornment,
  ListItem,
  TextField,
  Typography,
} from "@mui/material";
import { memo } from "react";
import { useDispatch } from "react-redux";
import CustomInput from "../../components/inputs/CustomInputs";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { SOLUTIONS, USER_ROLES, STATUS } from "../../utils/constants";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { getProdutApi } from "../../apis/product.api";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";
import { getsourceApi } from "../../apis/source.api";

import { QrCodeScanner } from "@mui/icons-material";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import FileInput from "../../components/upload/FileInput";
import QrScannerPopup from "../../components/Scanner/QrScannerPopup";
import GeoLocation from "../../components/inputs/Geolocation";
import { getCountryApi } from "../../apis/country.api";
import { getStateApi } from "../../apis/state.api";
import { getCityApi } from "../../apis/city.api";

const CreateQueryUi = ({
  id,
  filters,
  setFilters,
  setlistProblem,
  product,
  listProblem,
  setFiltersBoxId,
  filtersBoxId,
  BoxIDAutoCompleted,
  title,
  isUpdate,
  fields,
  setFields,
  loading,
  onSubmit,
  setVariant,
  variant1,
  CheckComplain,
}) => {
  const dispatch = useDispatch();
  const onScan = (data) => {
    setFields({ ...fields, err: "", box_id: data?.text });
  };
  const onQrBtnClick = () => {
    dispatch(
      openModal(
        <QrScannerPopup
          setFields={setFields}
          fields={fields}
          onScan={onScan}
          onClose={() => dispatch(closeModal("scanner"))}
        />,
        "sm",
        false,
        "scanner",
      ),
    );
  };

  return (
    <>
      <CustomDialog
        id={`${isUpdate ? "Query" : "Query"}`}
        loading={loading}
        err={fields.err}
        onSubmit={onSubmit}
        title={`${isUpdate ? "Update" : "Create"} ${title}`}
        closeText="Close"
        confirmText={`${isUpdate ? "Update" : "Submit"}`}
      >
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            <Box
              width={"90%"}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Typography>Ticket Number: {fields?.ticket_no}</Typography>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Typography>
                  Date: {moment(fields?.createdAt).format("DD/MM/YYYY")}
                </Typography>
              </Box>
            </Box>
            <Box mt={3} width={"100%"}>
              <PaddingBoxInDesktop
                mb={2}
                sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}
              >
                <Autocomplete
                  sx={{ width: "100%", color: "primary.main" }}
                  value={fields.product_id ?? null}
                  onChange={(event, newValue) => {
                    setFields({
                      ...fields,
                      err: "",
                      product_id: newValue ?? null,
                    });
                    setlistProblem(newValue ? newValue.problems : []);
                  }}
                  options={product ?? []}
                  getOptionLabel={(option) => option.name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  renderInput={(params) => (
                    <TextField
                      margin="dense"
                      {...params}
                      label="Product*"
                      variant="outlined"
                      placeholder="Select Product"
                      onChange={(e) =>
                        setFilters({ ...filters, search: e.target.value })
                      }
                    />
                  )}
                />
              </PaddingBoxInDesktop>

              <Box mt={3} mb={2}>
                <Typography variant="h4">Customer Details :</Typography>
              </Box>
              {CheckComplain && (
                <Box
                  gap={3}
                  flexDirection={"row"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box mt={1} width={"100%"}>
                    <FormControl color="primary" fullWidth variant="outlined">
                      <InputLabel
                        color="primary"
                        htmlFor="outlined-adornment-boxid"
                      >
                        Enter Box Id*
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-boxid"
                        value={fields?.box_id || ""}
                        onChange={(e) =>
                          setFields({
                            ...fields,
                            err: "",
                            box_id: e.target.value,
                          })
                        }
                        type="text"
                        autoFocus={true}
                        disabled={loading}
                        endAdornment={
                          <>
                            {loading && <CircularProgress size={30} />}
                            <InputAdornment position="end">
                              <IconButton onClick={onQrBtnClick} edge="end">
                                <QrCodeScanner />
                              </IconButton>
                            </InputAdornment>
                          </>
                        }
                        color="primary"
                        label="Enter Box Id*"
                      />
                    </FormControl>
                  </Box>
                  {fields?.box_id == "" && (
                    <Autocomplete
                      sx={{ width: "100%", color: "primary.main" }}
                        onChange={(event, newValue) => {
                          if (id) {
                               setFields({
                                 ...fields,
                                 err: "",
                                 box_id: newValue?.boxId ?? "",
                                 band_box_id: newValue?.band_box_id ?? "",
                                 manufacturer_date:
                                   newValue?.manufacturer_date ?? moment(),
                                 problems:
                                   newValue?.problems?.length > 0
                                     ? newValue?.problems
                                     : fields?.problems || [],
                               });
                          } else {
                            setFields({
                              ...fields,
                              err: "",
                              box_id: newValue?.boxId ?? "",
                              _id: newValue?._id ?? "",
                              customer_phone: newValue?.customer_phone ?? "",
                              customer_email: newValue?.customer_email ?? "",
                              customer_name: newValue?.customer_name ?? "",
                              customer_address: newValue?.customer_address ?? "",
                              band_box_id: newValue?.band_box_id ?? "",
                              ...(newValue?.product_id?._id && {
                                product_id: {
                                  _id: newValue?.product_id?._id ?? "",
                                  name: newValue?.product_id?.name ?? "",
                                },
                              }),
                              ...(newValue?.source_id?._id && {
                                source_id: {
                                  _id: newValue?.source_id?._id ?? "",
                                  title: newValue?.source_id?.title ?? "",
                                },
                              }),
                              manufacturer_date:
                                newValue?.manufacturer_date ?? moment(),
                              problems:
                                newValue?.problems?.length > 0
                                  ? newValue?.problems
                                  : fields?.problems || [],
                              other: newValue.other ? newValue.other : "",
                              country: newValue?.country ?? "",
                              state: newValue?.state ?? "",
                              city: newValue?.city ?? "",
                            });
                        }
                      }}
                      options={BoxIDAutoCompleted ?? []}
                      getOptionLabel={(option) => option.boxId}
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            label={option.boxId}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          margin="dense"
                          {...params}
                          label="Box Id*"
                          variant="outlined"
                          placeholder="Selected Box Id"
                          onChange={(e) =>
                            setFiltersBoxId({
                              ...filtersBoxId,
                              search: e.target.value,
                            })
                          }
                        />
                      )}
                    />
                  )}
                </Box>
              )}
              <Box
                mt={1}
                mb={1}
                gap={3}
                flexDirection={"row"}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <CustomInput
                  autoFocus={true}
                  disabled={loading}
                  value={fields.customer_name}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      customer_name: e.target.value,
                    })
                  }
                  type="text"
                  label={"Customer Name*"}
                />
                <CustomInput
                  disabled={loading}
                  value={fields.customer_email}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      customer_email: e.target.value,
                    })
                  }
                  type="text"
                  label={"Email"}
                />
              </Box>
              <Box
                gap={3}
                mb={1}
                flexDirection={"row"}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <CustomInput
                  disabled={loading}
                  value={fields.customer_phone}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      customer_phone: e.target.value,
                    })
                  }
                  type="number"
                  label={" Phone No.*"}
                />
                <CustomInput
                  disabled={loading}
                  value={fields.customer_address}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      customer_address: e.target.value,
                    })
                  }
                  type="text"
                  label={"Address*"}
                />
              </Box>
              <Grid2 container spacing={{ md: 2 }} size={12}>
                <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
                  <AsyncDropDown
                    key={fields.country}
                    // disabled={user.data.role !== USER_ROLES.ADMIN}
                    value={
                      fields.country
                        ? {
                            _id: fields?.country?._id || fields.country,
                            name: fields?.country?.name || fields.countryName,
                          }
                        : null
                    }
                    lazyFun={async (para) =>
                      await getCountryApi({ ...para, allStatus: true })
                    }
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.name}</ListItem>;
                    }}
                    onChange={async (changedVal) => {
                      setFields((prev) => ({
                        ...prev,
                        country: changedVal?._id || "",
                        countryName: changedVal?.name || "",
                        state: "",
                        stateName: "",
                        city: "",
                        cityName: "",
                      }));
                    }}
                    titleKey={"name"}
                    valueKey={"_id"}
                    InputComponent={(params) => (
                      <CustomInput
                        placeholder={"Select Country"}
                        label={"Country"}
                        {...params}
                        margin="none"
                      />
                    )}
                  />
                </Grid2>
                <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
                  <AsyncDropDown
                    key={fields.country}
                    disabled={!fields.country}
                    value={
                      fields.country && fields.state
                        ? {
                            _id: fields.state._id || fields.state,
                            name: fields.state.name || fields.stateName,
                          }
                        : null
                    }
                    lazyFun={async (para) =>
                      await getStateApi({
                        ...para,
                        allStatus: true,
                        country: fields.country,
                      })
                    }
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.name}</ListItem>;
                    }}
                    onChange={async (changedVal) => {
                      setFields((prev) => ({
                        ...prev,
                        state: changedVal?._id || "",
                        stateName: changedVal?.name || "",
                        city: "",
                        cityName: "",
                      }));
                    }}
                    titleKey={"name"}
                    valueKey={"_id"}
                    InputComponent={(params) => (
                      <CustomInput
                        placeholder={"Select State"}
                        label={"State"}
                        {...params}
                        margin="none"
                      />
                    )}
                  />
                </Grid2>
                <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
                  <AsyncDropDown
                    key={fields.state}
                    disabled={!(fields.country && fields.state)}
                    value={
                      fields.country && fields.state && fields.city
                        ? {
                            _id: fields.city._id || fields.city,
                            name: fields.city.name || fields.cityName,
                          }
                        : null
                    }
                    lazyFun={async (para) =>
                      await getCityApi({
                        ...para,
                        allStatus: true,
                        state: fields.state,
                      })
                    }
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.name}</ListItem>;
                    }}
                    onChange={async (changedVal) => {
                      setFields((prev) => ({
                        ...prev,
                        city: changedVal?._id || "",
                        cityName: changedVal?.name || "",
                      }));
                    }}
                    titleKey={"name"}
                    valueKey={"_id"}
                    InputComponent={(params) => (
                      <CustomInput
                        placeholder={"Select City"}
                        label={"City"}
                        {...params}
                        margin="none"
                      />
                    )}
                  />
                </Grid2>
              </Grid2>
              {CheckComplain && (
                <DesktopDatePicker
                  label="Manufacturing Date*"
                  disableFuture
                  inputFormat="DD/MM/yyyy"
                  renderInput={(props) => <CustomInput {...props} />}
                  autoFocus={true}
                  disabled={loading}
                  value={
                    fields?.manufacturer_date
                      ? moment(fields?.manufacturer_date)
                      : null
                  }
                    onChange={(val) => {
                      if (val && val.isValid()) {
                        if (val.isAfter(moment(), "day")) {
                          setFields({
                            ...fields,
                            err: "Manufacturing date cannot be in the future",
                            manufacturer_date: "",
                          });
                          return;
                        }

                        setFields({
                          ...fields,
                          err: "",
                          manufacturer_date: val.toISOString(),
                        });
                      } else {
                        setFields({
                          ...fields,
                          err: "",
                          manufacturer_date: "",
                        });
                      }
                    }}
                />
              )}
              {fields?.product_id?.is_3yr_warranty && (
                <Box mt={2}>
                  <FormControl>
                    {/* <FormLabel component="legend">Conclusion</FormLabel> */}
                    <FormGroup component="fieldset" row>
                      {
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={fields.is_warranty_3_yr}
                              onChange={(e) => {
                                setFields({
                                  ...fields,
                                  err: "",
                                  is_warranty_3_yr: true,
                                });
                              }}
                              name="enable_warranty_3_yr"
                            />
                          }
                          label="Enable 3-Year Warranty Coverage"
                          labelPlacement="end"
                        />
                      }
                    </FormGroup>
                  </FormControl>
                </Box>
              )}
              {CheckComplain && (
                <PaddingBoxInDesktop
                  mt={3}
                  mb={1}
                  sx={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <AsyncDropDown
                    value={
                      fields.source_id?._id
                        ? {
                            _id: fields.source_id?._id,
                            title: fields.source_id?.title,
                          }
                        : null
                    }
                    lazyFun={async (para) =>
                      await getsourceApi({ ...para, allStatus: true })
                    }
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.title}</ListItem>;
                    }}
                    onChange={async (changedVal) => {
                      setFields({
                        ...fields,
                        source_id: changedVal ? changedVal._id : null,
                      });
                    }}
                    titleKey={"title"}
                    valueKey={"_id"}
                    InputComponent={(params) => (
                      <CustomInput
                        placeholder={"Source*"}
                        {...params}
                        margin="none"
                      />
                    )}
                  />
                </PaddingBoxInDesktop>
              )}

              <Box
                gap={3}
                mt={2}
                flexDirection={"row"}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                {" "}
                {id && (
                  <CustomInput
                    disabled={loading}
                    value={fields.complain_remarks}
                    onChange={(e) =>
                      setFields({
                        ...fields,
                        err: "",
                        complain_remarks: e.target.value,
                      })
                    }
                    type="text"
                    label={"Summary of call*"}
                  />
                )}
                <Autocomplete
                  sx={{ width: "100%", color: "primary.main" }}
                  value={
                    listProblem?.filter((problem) =>
                      fields.problems.includes(problem.name),
                    ) || []
                  }
                  multiple
                  onChange={(event, newValue) => {
                    setFields({
                      ...fields,
                      err: "",
                      problems: newValue.map((val) => val?.name),
                    });
                  }}
                  options={listProblem ?? []}
                  getOptionLabel={(option) => option.name}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip label={option.name} {...getTagProps({ index })} />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      margin="dense"
                      {...params}
                      label="Problems*"
                      variant="outlined"
                      placeholder="Select Problems"
                    />
                  )}
                />
                {fields?.problems?.map(
                  (item) =>
                    item.toLowerCase() === "other" && (
                      <CustomInput
                        disabled={loading}
                        value={fields.other}
                        onChange={(e) =>
                          setFields({
                            ...fields,
                            err: "",
                            other: e.target.value,
                          })
                        }
                        type="text"
                        label={" Other Problem*"}
                      />
                    ),
                )}
              </Box>

              <Box mt={4}>
                <Box>
                  <Typography variant="h3">Mode Of Query Solving :</Typography>
                </Box>
                <Grid
                  mt={1}
                  container
                  spacing={3}
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                >
                  <Grid item xs={4} sm={4} md={4}>
                    <Button
                      variant={
                        fields.solved_in === "call" ||
                        variant1 === SOLUTIONS.CALL
                          ? "contained"
                          : "outlined"
                      }
                      onClick={(e) => {
                        setVariant(SOLUTIONS.CALL);
                        setFields({
                          ...fields,
                          err: "",
                          solved_in: SOLUTIONS.CALL,
                          status: [
                            {
                              status_role: STATUS.COMPLETED,
                              role: USER_ROLES.CRM_TEAM,
                            },
                            {
                              status_role: STATUS.COMPLETED,
                              role: USER_ROLES.LD,
                            },
                          ],
                        });
                      }}
                      fullWidth
                    >
                      <Typography>Call</Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Button
                      onClick={() => {
                        setVariant(SOLUTIONS.Videao_Call);
                        setFields({
                          ...fields,
                          err: "",
                          solved_in: SOLUTIONS.Videao_Call,
                          status: [
                            {
                              status_role: STATUS.COMPLETED,
                              role: USER_ROLES.CRM_TEAM,
                            },
                            {
                              status_role: STATUS.COMPLETED,
                              role: USER_ROLES.LD,
                            },
                          ],
                        });
                      }}
                      variant={
                        fields.solved_in === "vc" ||
                        variant1 === SOLUTIONS.Videao_Call
                          ? "contained"
                          : "outlined"
                      }
                      fullWidth
                    >
                      <Typography>Video Call</Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Button
                      onClick={() => {
                        setVariant(SOLUTIONS.REPAIR);
                        setFields({
                          ...fields,
                          err: "",
                          solved_in: SOLUTIONS.REPAIR,
                          status: [
                            {
                              status_role: STATUS.YET_TO_RECEIVED,
                              role: USER_ROLES.LD,
                            },
                            {
                              status_role: STATUS.YET_TO_RECEIVED,
                              role: USER_ROLES.CRM_TEAM,
                            },
                          ],
                        });
                      }}
                      variant={
                        fields.solved_in === "repairing" ||
                        variant1 === SOLUTIONS.REPAIR
                          ? "contained"
                          : "outlined"
                      }
                      fullWidth
                    >
                      <Typography>Repair</Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Box>
              {variant1 === SOLUTIONS.REPAIR && (
                <Box mt={4}>
                  <Grid xs={12} md={6} item>
                    <Box>
                      <FileInput
                        onDelete={(filesToDelete) => {
                          setFields({
                            ...fields,
                            err: "",
                            device_photo: "",
                          });
                        }}
                        onChange={(files) => {
                          setFields({
                            ...fields,
                            err: "",
                            device_photo: files,
                          });
                        }}
                        defaults={
                          fields?.device_photo ? [fields?.device_photo] : []
                        }
                        accept="image/*,.pdf"
                        title="Device Photo"
                        subTitle="Only png,jpeg,jpg,pdf files are allowed! less than 1 MB"
                      />
                    </Box>
                  </Grid>
                </Box>
              )}
            </Box>
          </>
        )}
      </CustomDialog>
    </>
  );
};

export default memo(CreateQueryUi);
